/*
 * DDU · Patch JS para el botón "MÁS / MORE" del overflow-list (header desktop)
 *
 * Problema original: la clase OverflowList del theme declara on:focus/on:pointerenter
 *   en el <li slot="more"> pero NO implementa activate()/deactivate() → el dropdown
 *   nunca aparecía. Se polyfillea + se construye un panel propio anclado al body.
 *
 * Fix 2026-06 (reporte Thibisay "al tocar MORE el botón desaparece"):
 *   - El panel se cerraba al mover el cursor del botón al panel (gap + handlers de
 *     hover del panel cableados en un setTimeout que corría antes de existir el panel).
 *   - En touch ("tocar") el modelo hover no sirve.
 *   Solución: interacción CLICK-first (toggle), detección del trigger por composedPath
 *   (atraviesa shadow DOM), cierre por click-afuera / click-en-item, hover como mejora
 *   de escritorio con timer cancelable, y panel pegado al botón (sin gap).
 */
(function () {
  'use strict';

  var PANEL_SEL = '.ddu-overflow-panel[data-host="ddu"]';
  var _hideTimer = null;
  var _activeHost = null;

  function cancelHide() { if (_hideTimer) { clearTimeout(_hideTimer); _hideTimer = null; } }
  function scheduleHide() { cancelHide(); _hideTimer = setTimeout(closeNow, 320); }
  function closeNow() {
    cancelHide();
    var panel = document.querySelector(PANEL_SEL);
    if (panel) panel.style.display = 'none';
    _activeHost = null;
  }

  function getOrCreatePanel() {
    var panel = document.querySelector(PANEL_SEL);
    if (panel) return panel;
    panel = document.createElement('ul');
    panel.className = 'ddu-overflow-panel';
    panel.setAttribute('data-host', 'ddu');
    panel.style.cssText = [
      'position:fixed', 'min-width:220px', 'background:#0a0c06',
      'border:1px solid rgba(201,169,97,.3)', 'border-radius:4px',
      'padding:10px 16px', 'margin:0', 'z-index:99999',
      'box-shadow:0 8px 32px rgba(0,0,0,.5)', 'list-style:none', 'display:none'
    ].join(';');
    // Panel hover (escritorio): mantener abierto mientras el cursor esté encima
    panel.addEventListener('pointerenter', cancelHide);
    panel.addEventListener('pointerleave', scheduleHide);
    document.body.appendChild(panel);
    return panel;
  }

  function positionPanel(panel, host) {
    var moreLi = host.querySelector('li[slot="more"]');
    var anchor = moreLi;
    var shadowMore = host.shadowRoot && host.shadowRoot.querySelector('li[part="more"]');
    if (shadowMore && shadowMore.getBoundingClientRect().height > 0) anchor = shadowMore;
    if (!anchor) anchor = host;
    var r = anchor.getBoundingClientRect();
    panel.style.top = r.bottom + 'px';      /* pegado al botón: sin gap que rompa el hover */
    // anclar el borde izquierdo al botón (MÁS está a la izquierda), clamp para no salirse
    var left = Math.max(8, Math.min(r.left, window.innerWidth - 240));
    panel.style.left = left + 'px';
    panel.style.right = 'auto';
  }

  function findOverflowItems(host) {
    var explicit = Array.prototype.slice.call(host.querySelectorAll('[slot="overflow"]'));
    if (explicit.length) return explicit;
    var moreLi = host.querySelector('li[slot="more"]');
    var hostRect = host.getBoundingClientRect();
    var items = Array.prototype.slice.call(host.children).filter(function (c) {
      return c.tagName === 'LI' && c.getAttribute('slot') !== 'more';
    });
    var moreLeft = moreLi ? moreLi.getBoundingClientRect().left : hostRect.right;
    return items.filter(function (li) {
      var r = li.getBoundingClientRect();
      return r.right > moreLeft + 5 || r.left >= hostRect.right - 5;
    });
  }

  function showOverflow(host) {
    if (!host) return;
    cancelHide();
    _activeHost = host;
    var panel = getOrCreatePanel();
    var overflowItems = findOverflowItems(host);
    if (!overflowItems.length) { panel.style.display = 'none'; return; }
    panel.innerHTML = '';
    overflowItems.forEach(function (li) {
      var a = li.querySelector('a');
      if (!a) return;
      var clone = document.createElement('li');
      clone.style.cssText = 'margin:6px 0;list-style:none';
      var newA = document.createElement('a');
      newA.href = a.getAttribute('href') || '#';
      newA.textContent = a.textContent.trim();
      newA.style.cssText = [
        'display:block', 'padding:9px 4px', 'color:#f4ecd8',
        'font-family:Cinzel,Cormorant Garamond,Georgia,serif', 'font-size:12px',
        'letter-spacing:.18em', 'text-transform:uppercase', 'text-decoration:none',
        'white-space:nowrap', 'transition:color .2s ease'
      ].join(';');
      newA.addEventListener('pointerenter', function () { newA.style.color = '#c9a961'; });
      newA.addEventListener('pointerleave', function () { newA.style.color = '#f4ecd8'; });
      // navegar al tocar/click (cierra y deja seguir el link)
      newA.addEventListener('click', function () { setTimeout(closeNow, 0); });
      clone.appendChild(newA);
      panel.appendChild(clone);
    });
    panel.style.display = 'block';
    panel.style.visibility = 'visible';
    positionPanel(panel, host);
  }

  function isOpen() {
    var panel = document.querySelector(PANEL_SEL);
    return panel && panel.style.display === 'block';
  }

  // ¿el evento ocurrió sobre el control "MÁS"? (atraviesa shadow DOM con composedPath)
  function isMoreTrigger(e) {
    var path = (e.composedPath && e.composedPath()) || [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.getAttribute) continue;
      if (el.getAttribute('slot') === 'more' || el.getAttribute('part') === 'more') return true;
      if (el.classList && (el.classList.contains('menu-list__more') || el.classList.contains('overflow-list__more'))) return true;
    }
    return false;
  }
  function hostFromEvent(e) {
    var path = (e.composedPath && e.composedPath()) || [];
    for (var i = 0; i < path.length; i++) {
      if (path[i] && path[i].tagName === 'OVERFLOW-LIST') return path[i];
    }
    return document.querySelector('overflow-list');
  }

  function patchClass() {
    var Ctor = customElements.get('overflow-list');
    if (!Ctor) return false;
    if (Ctor.prototype.activate && Ctor.prototype.deactivate) return true;
    Ctor.prototype.activate = function () { showOverflow(this); };
    Ctor.prototype.deactivate = function () { scheduleHide(); };
    return true;
  }

  function wireUpDirectly(host) {
    if (!host || host.__dduOverflowWired) return;
    host.__dduOverflowWired = true;
    var moreLi = host.querySelector('li[slot="more"]');
    if (!moreLi) return;
    // Escritorio: hover sobre el botón abre; salir programa cierre (cancelable por el panel)
    moreLi.addEventListener('pointerenter', function () { showOverflow(host); });
    moreLi.addEventListener('pointerleave', scheduleHide);
    moreLi.addEventListener('focusin', function () { showOverflow(host); });
    moreLi.addEventListener('focusout', scheduleHide);
  }

  // CLICK global (touch + escritorio): toggle si es el MÁS, cerrar si es afuera
  document.addEventListener('click', function (e) {
    if (isMoreTrigger(e)) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen()) { closeNow(); } else { showOverflow(hostFromEvent(e)); }
      return;
    }
    var panel = document.querySelector(PANEL_SEL);
    if (isOpen() && panel && !panel.contains(e.target)) closeNow();
  }, true);

  window.addEventListener('resize', function () { if (isOpen() && _activeHost) positionPanel(getOrCreatePanel(), _activeHost); });
  window.addEventListener('scroll', function () { if (isOpen() && _activeHost) positionPanel(getOrCreatePanel(), _activeHost); }, { passive: true });

  function patchAllInstances() { document.querySelectorAll('overflow-list').forEach(wireUpDirectly); }

  function init() {
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('overflow-list').then(function () { patchClass(); patchAllInstances(); });
    }
    patchClass();
    patchAllInstances();
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () { patchAllInstances(); });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;(function(){function t(){try{fetch('/cart.js').then(function(r){return r.json()}).then(function(c){var i=c.items&&c.items[0];var p={ItemCount:c.item_count};p.$value=(c.total_price||0)/100;if(i){p.ItemName=i.product_title;p.URL=location.origin+i.url;if(i.image){p.ImageURL=i.image}}window.klaviyo=window.klaviyo||[];window.klaviyo.push(['track','Added to Cart',p])})}catch(e){}}document.addEventListener('submit',function(e){var f=e.target;if(f&&f.action&&f.action.indexOf('/cart/add')>-1){setTimeout(t,1200)}},true)})();